module.exports = __webpack_public_path__ + "images/stickers/taco-angry@2x.88141aecd4c8fbdc3ff1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-angry@2x.png
// module id = lM4p
// module chunks = 24